module.exports = __webpack_public_path__ + "img/selected0-min.8b0b99c4.png";